export interface Partners {
    partnersSignal: any | null;
    loadingSignal: boolean;
  }
  
  export const initialState: Partners = {
    partnersSignal: null,
    loadingSignal: false,
  };